import { FC, useCallback, useEffect } from 'react'
import styles from './OrderLog.module.scss'
import OrderLogList from './components/OrderLogList'
import { CircularProgress, Pagination } from '@mui/material'
import UseInvoice from '../../modules/invoice/presentation/hooks/UseInvoice'
import UseDeviceStore from '../../modules/device/store/DeviceStore'
import UseOrderLog from './hook/UseOrderLog'
import UseSessionStore from '../../modules/session/store/SessionStore'
import { IOrderLog } from '../../modules/orderLog/domain/dtos/IOrderLog'
import { useI18n } from '../../hooks/useI18n'
export interface IOrderLogProps {
    //propertys
}
const OrderLogFragment: FC<IOrderLogProps> = () => {
    const { t } = useI18n();
    const [receiptPrinterSector] = UseDeviceStore(state => [state.device, state.receiptPrinterSector])
    const { emitInvoice } = UseInvoice();
    const { printInvoice, isLoadingOrders, currentPage, orders, getOrdersInvoice } = UseOrderLog();
    const [session] = UseSessionStore(state => [state.session])

    useEffect(() => {
        getOrdersInvoice();
    }, [getOrdersInvoice]);


    const emitInvoiceHandler = useCallback(async (order: IOrderLog) => {
        var response = await emitInvoice(order, undefined, true)
        getOrdersInvoice();
        return response;
    }, [emitInvoice, getOrdersInvoice])

    return (
        <div id={styles.OrderLog} >
            {isLoadingOrders &&
                <div className={styles.loading} >
                    <CircularProgress size={18} />
                </div>
            }
            {!isLoadingOrders && orders?.Items.length
                ? <>
                    <OrderLogList
                        orders={orders?.Items}
                        emitInvoice={emitInvoiceHandler}
                        printInvoice={printInvoice}
                        disabledPrinter={!receiptPrinterSector}
                        disabledEmitInvoice={!session?.emitInvoice}
                    />

                    <div className={styles.pagination}>
                        <Pagination
                            page={currentPage}
                            color="primary"
                            className={styles.pagination}
                            defaultPage={1}
                            hideNextButton={!orders.HasNext}
                            count={orders.HasNext ? orders.Page + 1 : orders.Page}
                            onChange={(ev, page) => getOrdersInvoice(page)}
                        />
                    </div>
                </> : null
            }

            {!isLoadingOrders && !orders?.Items.length && <span style={{ margin: "auto", color: "#5F5F5F" }}><b>{t('orderHistory.noOrders')}</b> {t('orderHistory.noOrdersMessage')}</span>}
        </div>
    )
}
export default OrderLogFragment